import { createContext, useContext } from 'react';

export type MiniModalRedirectContextType = {
  isLoading?: boolean;
  courseSlug?: string;
  s12nSlug?: string;
  s12nProductVariant?: string;
  isProject?: boolean;
};

const MiniModalRedirectContext = createContext<MiniModalRedirectContextType>({});

export const useMiniModalRedirectData = () => useContext(MiniModalRedirectContext);

export default MiniModalRedirectContext;
